export default __webpack_public_path__ + "static/media/Waterline tanks 1.6 ratio.299fd2f0.png";